"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronDownIcon = function ChevronDownIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      viewBox = _ref.viewBox,
      fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_SVG.default, {
    style: style,
    width: width || '32',
    height: height || '32',
    viewBox: viewBox || "0 0 32 32",
    fill: fill,
    className: className,
    path: "M16 21.5858L25.2929 12.2929C25.6834 11.9024 26.3166 11.9024 26.7071 12.2929C27.0976 12.6834 27.0976 13.3166 26.7071 13.7071L16.7071 23.7071C16.3166 24.0976 15.6834 24.0976 15.2929 23.7071L5.29289 13.7071C4.90237 13.3166 4.90237 12.6834 5.29289 12.2929C5.68342 11.9024 6.31658 11.9024 6.70711 12.2929L16 21.5858Z"
  });
};

var _default = ChevronDownIcon;
exports.default = _default;